import * as log from "loglevel";
import * as mobx from "mobx";
import * as React from "react";
import * as ReactDOM from "react-dom";

import { RootStore } from "./stores/root-store";

import { autorun, observable } from "mobx";
import { observer, Provider } from "mobx-react";
import { Route, Router } from "react-router";
import { HashRouter } from "react-router-dom";

import { config } from "./config";


import { MainView } from "./views/main-view";

declare var toastr: any;
toastr.options = config.toastrOpts;
mobx.useStrict(config.strict);
log.setLevel(config.logLevel);

ReactDOM.render(
	<Provider {...RootStore}>
		<HashRouter>
			<MainView />
		</HashRouter>
	</Provider>,
	document.getElementById("jump-root")
);



// WEBPACK FOOTER //
// ./src/index.tsx